var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3238 15.2784H2.6444C2.27098 15.2784 1.96826 14.9757 1.96826 14.6022V6.81109C1.96826 6.43767 2.27098 6.13495 2.6444 6.13495H19.3238C19.6972 6.13495 19.9999 6.43767 19.9999 6.81109V14.6022C19.9999 14.9757 19.6972 15.2784 19.3238 15.2784Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9865 14.321L2.94376 15.2783H19.3237C19.6971 15.2783 19.9998 14.9755 19.9998 14.6021V6.81097C19.9998 6.43755 19.6971 6.13477 19.3237 6.13477H2.6444C2.27098 6.13477 1.96826 6.43749 1.96826 6.81097V14.2816L1.9865 14.321Z",
    fill: "#072553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3096 14.264H1.63024C1.25682 14.264 0.954102 13.9613 0.954102 13.5879V5.79681C0.954102 5.42339 1.25682 5.12067 1.63024 5.12067H18.3096C18.6831 5.12067 18.9858 5.42339 18.9858 5.79681V13.5879C18.9858 13.9613 18.6831 14.264 18.3096 14.264Z",
    fill: "url(#paint0_linear_9075_40282)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.972461 13.3068L1.92973 14.264H18.3096C18.6831 14.264 18.9858 13.9613 18.9858 13.5879V5.79681C18.9858 5.42339 18.6831 5.12067 18.3096 5.12067H1.63024C1.25682 5.12067 0.954102 5.42339 0.954102 5.79681V13.2674L0.972461 13.3068Z",
    fill: "url(#paint1_linear_9075_40282)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3555 13.3101H0.676142C0.30272 13.3101 0 13.0073 0 12.6339V4.84283C0 4.46941 0.30272 4.16669 0.676142 4.16669H17.3555C17.7289 4.16669 18.0317 4.46941 18.0317 4.84283V12.6339C18.0317 13.0073 17.729 13.3101 17.3555 13.3101Z",
    fill: "url(#paint2_linear_9075_40282)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0132 6.09974C16.524 6.07434 16.1241 5.67347 16.0987 5.18429C16.0931 5.07606 16.1058 4.97169 16.1332 4.87335H1.89873C1.92618 4.97156 1.93888 5.076 1.93321 5.18423C1.90776 5.67347 1.50789 6.07434 1.0187 6.09967C0.851347 6.10839 0.69283 6.07434 0.552734 6.00775V11.4688C0.692954 11.4022 0.851596 11.3682 1.01901 11.3769C1.50826 11.4025 1.90794 11.8035 1.93321 12.2927C1.93875 12.4008 1.92618 12.5051 1.89873 12.6033H16.1331C16.1058 12.5051 16.0931 12.4008 16.0987 12.2927C16.124 11.8035 16.5237 11.4025 17.0129 11.3769C17.1803 11.3681 17.339 11.4022 17.4791 11.4688V6.00775C17.3391 6.0744 17.1805 6.10839 17.0132 6.09974Z",
    fill: "url(#paint3_linear_9075_40282)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8292 10.7089H12.2334V11.7433H15.8292V10.7089Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01566 11.0794C10.3088 11.0794 11.357 10.0311 11.357 8.73801C11.357 7.44492 10.3088 6.39667 9.01566 6.39667C7.72257 6.39667 6.67432 7.44492 6.67432 8.73801C6.67432 10.0311 7.72257 11.0794 9.01566 11.0794Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79794 5.73334H2.20215V6.76778H5.79794V5.73334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9075_40282",
    x1: 0.953944,
    y1: 9.69268,
    x2: 18.9853,
    y2: 9.69268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009E74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9075_40282",
    x1: 11.3264,
    y1: 14.8627,
    x2: 8.42674,
    y2: 3.38077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005841",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009E74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9075_40282",
    x1: -0.000129781,
    y1: 8.73874,
    x2: 18.0312,
    y2: 8.73874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7F3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61DB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9075_40282",
    x1: 4.30578,
    y1: 4.02877,
    x2: 15.7796,
    y2: 15.5025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009E74"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.164b3939e4077040b8856ffb0ebffa13.svg";
export { ForwardRef as ReactComponent };